// extracted by mini-css-extract-plugin
export var emptyState = "_65-d";
export var statCard = "_65-c";
export var table = "_65-0";
export var tableCell = "_65-4";
export var tableCellClickable = "_65-5 _65-4";
export var tableCellDefault = "_65-6 _65-4";
export var tableCellEmpty = "_65-8";
export var tableCellWithValue = "_65-7";
export var tableContainer = "_65-e";
export var tableHeaderWeight = "_65-1";
export var tableHeaderZone = "_65-2";
export var tableRowHeader = "_65-3";
export var viewModeButton = "_65-9";
export var viewModeButtonActive = "_65-a _65-9";
export var viewModeButtonInactive = "_65-b _65-9";